import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ src, alt }) => {
	return (
		<div className="logo-container" style={{ height: '80px' }}>
			<img
				src={src}
				alt={alt || 'Logo'}
				style={{ height: '100%', objectFit: 'contain' }}
			/>
		</div>
	);
};

Image.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string
};

export default Image;
